import { Fragment, useState, useEffect } from "react";
import { Transition, TransitionChild } from "@headlessui/react";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { CiUser, CiCalendar } from "react-icons/ci";
import { useStore, likedData, useAttendeeStore } from "../../utils/store";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import authApi from "../../apis/auth.api";
import authApiAdmin from "../../apis/adminApis/authAdmin.api";
import authApiOrganiser from "../../apis/organiserApis/authOrganiser.api";
import CitySelectorModal from "./CitySelectorModal";
import CurrencySwitcher from "../CurrencySwitcher";
import LanguageSwitcher from "../LanguageSwitcher";
import { useLanguage } from "../LanguageContext";

const navigation = [
  { name: "Home", href: "/", key: "nav.home" },
  { name: "Events", href: "/eventslist", key: "nav.events" },
  { name: "Movies", href: "/movieslist", key: "nav.movies" },
  // { name: "Pricing", href: "/Pricing" },
  { name: "Contact", href: "/contact", key: "nav.contact" },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Navbar() {
  const { t } = useLanguage();
  const { userLocation, setUserLocation, basicSettings, setFollowers } =
    useStore();

  const {
    user: { isAuthenticated, role, data },
    verifySession,
    setUser,
  } = useAttendeeStore();

  const setLikedEvents = likedData((state) => state.setLikedEvents);
  const setLikedMovies = likedData((state) => state.setLikedMovies);

  const [dashBoardLink, setDashBoardLink] = useState(null);
  const { pathname } = useLocation();

  const [askLocation, setAskLocation] = useState(false);
  const [locationLabel, setLocationLabel] = useState(
    localStorage.getItem("userLocation") || "All"
  );

  useEffect(() => {
    const hasSelectedLocation = localStorage.getItem("selectedlocation");

    // Open modal only if on homepage and location is not set
    if (!hasSelectedLocation && pathname === "/") {
      setAskLocation(true);
    } else {
      setAskLocation(false);
    }
  }, [pathname]);

  const navigate = useNavigate();

  const locations = [
    {
      value: "Berlin",
      name: "Berlin",
      img: "https://tse3.mm.bing.net/th?id=OIP.VQU7QgXSNtCUVN6ytXR4sQHaEK&pid=Api&P=0&h=180",
      country: "Germany",
    },
    {
      value: "Hamburg",
      name: "Hamburg",
      img: "https://a.cdn-hotels.com/gdcs/production157/d573/37de0393-4b4e-42fc-8510-e2ca9c294b48.jpg",
      country: "Germany",
    },
    {
      value: "Munich",
      name: "Munich",
      img: "https://www.voyageavecnous.fr/wp-content/uploads/2022/06/neuschwanstein.jpg",
      country: "Germany",
    },
    {
      value: "Cologne",
      name: "Cologne",
      img: "https://www.roadaffair.com/wp-content/uploads/2017/10/cologne-night-germany-shutterstock_426521938.jpg",
      country: "Germany",
    },
    {
      value: "Frankfurt",
      name: "Frankfurt",
      img: "https://tse3.mm.bing.net/th?id=OIP.vcRW4Q6xXyQAm3Mh4K8zhQHaEO&pid=Api&P=0&h=180",
      country: "Germany",
    },
    {
      value: "Stuttgart",
      name: "Stuttgart",
      img: "https://tse3.mm.bing.net/th?id=OIP.Ve9fCvD3zjXSQs46UyN_SgHaDu&pid=Api&P=0&h=180",
      country: "Germany",
    },
    {
      value: "Düsseldorf",
      name: "Düsseldorf",
      img: "https://tse4.mm.bing.net/th?id=OIP.oO9cUFByJNdShYsOpTQBKQHaEJ&pid=Api&P=0&h=180",
      country: "Germany",
    },
    {
      value: "Dortmund",
      name: "Dortmund",
      img: "https://a.cdn-hotels.com/gdcs/production142/d1977/4406e410-a527-11e8-85aa-0242ac110006.jpg",
      country: "Germany",
    },
    {
      value: "Leipzig",
      name: "Leipzig",
      img: "https://tse4.mm.bing.net/th?id=OIP.jm_RJzLh7TtYjy6o8wLFsgHaE8&pid=Api&P=0&h=180",
      country: "Germany",
    },
    {
      value: "Essen",
      name: "Essen",
      img: "https://tse1.mm.bing.net/th?id=OIP.oZNICLa01ykRAelfB6U9OAHaE7&pid=Api&P=0&h=180",
      country: "Germany",
    },
    {
      value: "Netherlands",
      name: "Netherlands",
      img: "https://www.holland.com/upload_mm/2/3/6/75601_fullimage_aerial%20view%20of%20downtown%20amsterdam%2C%20the%20netherlands%20during%20a%20dramatic%20beautiful%20sunset%20foto%20repistu%20via%20istock.jpg",
      country: "Netherlands",
    },
    {
      value: "Belgium",
      name: "Belgium",
      img: "https://lp-cms-production.imgix.net/2022-05/GettyRF_597070535.jpg",
      country: "Belgium",
    },
    {
      value: "Bremen",
      name: "Bremen",
      img: "https://images.unsplash.com/photo-1720288481331-77aac80facbf?q=80&w=1856&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      country: "Germany",
    },
    {
      value:"Milano",
      name:"Milano",
      img:"https://images.unsplash.com/photo-1572602648934-1d98de6dab48?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      country:"Italy",
    }
  ];

  const handleCloseModal = (city) => {
    if (city === "All") {
      const lat = localStorage.getItem("userLat") || 17.385;
      const lng = localStorage.getItem("userLng") || 78.4867;
      setUserLocation({ lat, lng });

      localStorage.removeItem("userLocation");
      setLocationLabel("All");
    } else {
      const lat = localStorage.getItem("userLat") || 17.385;
      const lng = localStorage.getItem("userLng") || 78.4867;
      setUserLocation({ lat, lng, city });
      localStorage.setItem("userLocation", city);
      setLocationLabel(city);
    }
    localStorage.setItem("selectedlocation", "true");
    setAskLocation(false);
  };

  const handleLogout = () => {
    const logoutFn = {
      attendee: authApi.handleLogout,
      organizer: authApiOrganiser.handleLogoutOrg,
      admin: authApiAdmin.handleLogoutAdmin,
    }[role];

    logoutFn?.({
      success: () => {
        setUser(null);
        setFollowers(null);
        setLikedEvents(null);
        setLikedMovies(null);
        toast.success("Logout successfully", {
          position: "top-center",
          autoClose: 2000,
        });
        navigate("/");
      },
      error: () => {
        toast.error(`Error while logout ${role}`, {
          position: "top-center",
          autoClose: 2000,
        });
      },
    });
  };

  useEffect(() => {
    verifySession();
  }, []);

  useEffect(() => {
    if (role === "attendee") setDashBoardLink("/dashboard");
    else if (role === "organizer") setDashBoardLink("/organizer");
    else if (role === "admin") setDashBoardLink("/admin");
    else if (role == "scanner") setDashBoardLink("/scanner/dashboard");
  }, [role]);
  const [isOpen, setOpen] = useState(false);
  return (
    <>
      <Disclosure
        as="nav"
        className={`w-full sticky top-0 z-50 bg-gradient-to-br from-[#3a1c5c] via-[#52326b] to-[#662d50] text-white shadow-lg`}
      >
        {({ open }) => (
          <>
            {askLocation && (
              <>
                <CitySelectorModal
                  locations={locations}
                  handleCloseModal={handleCloseModal}
                  locationLabel={locationLabel}
                  isOpen={askLocation}
                  onClose={() => {
                    setAskLocation(false);
                  }}
                />
              </>
            )}

            <div className="mx-auto lg:max-w-8xl px-2 sm:px-6 lg:px-8">
              {/* Mobile layout: logo | spacer | location | avatar? | hamburger */}
              {/* Desktop layout: logo | nav-links | location | auth-buttons */}
              <div className="relative flex h-16 items-center justify-between">

                {/* Logo */}
                <div className="flex flex-shrink-0 items-center">
                  <Link to="/">
                    <img
                      className="w-28 sm:w-36 lg:w-44"
                      src={basicSettings?.logo}
                      alt={basicSettings?.website_title}
                    />
                  </Link>
                </div>

                {/* Desktop nav links (hidden on mobile) */}
                <div className="hidden lg:flex lg:ml-6 lg:flex-1 lg:justify-center">
                  <div className="flex space-x-2 justify-center items-center">
                    {navigation.map((item) => (
                      <a
                        key={item.name}
                        href={item.href}
                        className={classNames(
                          item.current
                            ? "bg-white/20 text-white"
                            : "text-gray-100 hover:bg-white/10 hover:text-white",
                          "rounded-lg px-4 py-2 text-sm font-semibold transition-all duration-200 hover:shadow-md",
                        )}
                        aria-current={item.current ? "page" : undefined}
                      >
                        {t(item.key, item.name)}
                      </a>
                    ))}
                  </div>
                </div>

                {/* Right side: location + create + auth + hamburger */}
                <div className="flex items-center gap-1.5">

                  {/* Location button — always visible */}
                  <button
                    onClick={() => setAskLocation(true)}
                    className="text-white font-semibold bg-white/10 hover:bg-white/20 border border-white/30 hover:border-white/50 transition-all duration-200 flex items-center text-xs justify-center px-2 py-1.5 rounded-lg shadow-md hover:shadow-lg shrink-0"
                    style={{ maxWidth: 90 }}
                  >
                    <span>📍</span>
                    <span className="ml-1 truncate" style={{ maxWidth: 52 }}>{locationLabel}</span>
                  </button>

                  <CurrencySwitcher compact />
                  <LanguageSwitcher compact />

                  {/* Desktop-only auth area */}
                  <div className="hidden lg:flex items-center gap-2">
                    {!data ? (
                      <>
                        <a
                          href="/registerOrganizer"
                          className="text-white font-semibold bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 transition-all duration-200 flex items-center justify-center px-4 py-2 rounded-lg shadow-md hover:shadow-lg"
                        >
                          {t("nav.create_events", "Create Events")}
                        </a>

                        <Menu as="div" className="relative ml-1">
                          <div>
                            <MenuButton className="relative flex text-sm">
                              <button className="text-white font-semibold bg-white/10 hover:bg-white/20 border border-white/30 hover:border-white/50 transition-all duration-200 rounded-lg px-5 py-2 shadow-md hover:shadow-lg">
                                {t("nav.login", "Login")}
                              </button>
                            </MenuButton>
                          </div>
                          <Transition
                            as={Fragment}
                            enter="transition ease-out duration-100"
                            enterFrom="transform opacity-0 scale-95"
                            enterTo="transform opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform opacity-100 scale-100"
                            leaveTo="transform opacity-0 scale-95"
                          >
                            <MenuItems className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-xl bg-white shadow-xl ring-1 ring-black ring-opacity-5 focus:outline-none overflow-hidden">
                              <MenuItem>
                                {({ focus }) => (
                                  <a
                                    href="/login"
                                    className={classNames(
                                      focus ? "bg-gradient-to-r from-indigo-50 to-purple-50" : "",
                                      "px-4 py-3 text-sm text-gray-700 font-medium flex items-center gap-2 transition-colors",
                                    )}
                                  >
                                    <CiUser size={18} />
                                    Attendee Login
                                  </a>
                                )}
                              </MenuItem>
                              <MenuItem>
                                {({ focus }) => (
                                  <a
                                    href="/organizerLogin"
                                    className={classNames(
                                      focus ? "bg-gradient-to-r from-indigo-50 to-purple-50" : "",
                                      "flex items-center gap-2 px-4 py-3 text-sm text-gray-700 font-medium transition-colors",
                                    )}
                                  >
                                    <CiCalendar size={18} />
                                    Organizer Login
                                  </a>
                                )}
                              </MenuItem>
                            </MenuItems>
                          </Transition>
                        </Menu>
                      </>
                    ) : (
                      <Menu as="div" className="relative ml-1">
                        <div className="flex text-center items-center text-white space-x-3">
                          <a
                            href="/registerOrganizer"
                            className="text-white font-semibold bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 transition-all duration-200 flex items-center justify-center px-4 py-2 rounded-lg shadow-md hover:shadow-lg"
                          >
                            Create Events
                          </a>
                          <p className="font-medium">Hello, {data?.username}</p>
                          <MenuButton className="relative flex rounded-full bg-white/20 hover:bg-white/30 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-slate-800 transition-all">
                            <span className="absolute -inset-1.5" />
                            <span className="sr-only">Open user menu</span>
                            {data?.photo ? (
                              <img
                                className="h-8 w-8 rounded-full"
                                src={data?.photo}
                                loading="lazy"
                                alt={`${data.first_name || "User"}'s profile picture`}
                              />
                            ) : (
                              <FontAwesomeIcon icon={faUser} className="h-8 w-8 text-white" />
                            )}
                          </MenuButton>
                        </div>
                        <Transition
                          as={Fragment}
                          enter="transition ease-out duration-100"
                          enterFrom="transform opacity-0 scale-95"
                          enterTo="transform opacity-100 scale-100"
                          leave="transition ease-in duration-75"
                          leaveFrom="transform opacity-100 scale-100"
                          leaveTo="transform opacity-0 scale-95"
                        >
                          <MenuItems className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-xl bg-white shadow-xl ring-1 ring-black ring-opacity-5 focus:outline-none overflow-hidden">
                            <MenuItem>
                              {({ focus }) => (
                                <a
                                  href={dashBoardLink}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className={classNames(
                                    focus ? "bg-gradient-to-r from-indigo-50 to-purple-50" : "",
                                    "block px-4 py-3 text-sm text-gray-700 font-medium transition-colors",
                                  )}
                                >
                                  Your Profile
                                </a>
                              )}
                            </MenuItem>
                            <MenuItem>
                              {({ focus }) => (
                                <button
                                  onClick={handleLogout}
                                  className={classNames(
                                    focus ? "bg-red-50 text-red-700" : "text-gray-700",
                                    "block w-full text-left px-4 py-3 text-sm font-medium transition-colors",
                                  )}
                                  type="button"
                                >
                                  Logout
                                </button>
                              )}
                            </MenuItem>
                          </MenuItems>
                        </Transition>
                      </Menu>
                    )}
                  </div>

                  {/* Mobile-only: show user avatar if logged in */}
                  {data && (
                    <Menu as="div" className="relative lg:hidden">
                      <MenuButton className="relative flex rounded-full bg-white/20 hover:bg-white/30 text-sm focus:outline-none focus:ring-2 focus:ring-white transition-all">
                        <span className="absolute -inset-1.5" />
                        <span className="sr-only">Open user menu</span>
                        {data?.photo ? (
                          <img
                            className="h-8 w-8 rounded-full"
                            src={data?.photo}
                            loading="lazy"
                            alt={`${data.first_name || "User"}'s profile picture`}
                          />
                        ) : (
                          <FontAwesomeIcon icon={faUser} className="h-8 w-8 text-white" />
                        )}
                      </MenuButton>
                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                      >
                        <MenuItems className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-xl bg-white shadow-xl ring-1 ring-black ring-opacity-5 focus:outline-none overflow-hidden">
                          <MenuItem>
                            {({ focus }) => (
                              <a
                                href={dashBoardLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={classNames(
                                  focus ? "bg-gradient-to-r from-indigo-50 to-purple-50" : "",
                                  "block px-4 py-3 text-sm text-gray-700 font-medium transition-colors",
                                )}
                              >
                                Your Profile
                              </a>
                            )}
                          </MenuItem>
                          <MenuItem>
                            {({ focus }) => (
                              <button
                                onClick={handleLogout}
                                className={classNames(
                                  focus ? "bg-red-50 text-red-700" : "text-gray-700",
                                  "block w-full text-left px-4 py-3 text-sm font-medium transition-colors",
                                )}
                                type="button"
                              >
                                Logout
                              </button>
                            )}
                          </MenuItem>
                        </MenuItems>
                      </Transition>
                    </Menu>
                  )}

                  {/* Hamburger menu — mobile only, always visible */}
                  <div className="lg:hidden flex-shrink-0">
                    <Disclosure.Button className="relative inline-flex items-center justify-center rounded-md p-2 text-white hover:bg-white/10 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white transition-all">
                      <span className="absolute -inset-0.5" />
                      <span className="sr-only">Open main menu</span>
                      {open ? (
                        <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                      ) : (
                        <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                      )}
                    </Disclosure.Button>
                  </div>

                </div>
              </div>
            </div>

            <DisclosurePanel className="lg:hidden bg-slate-800/95 backdrop-blur-sm">
              <div className="space-y-1 px-2 pb-3 pt-2">
                {navigation.map((item) => (
                  <DisclosureButton
                    key={item.name}
                    as="a"
                    href={item.href}
                    className={classNames(
                      item.current
                        ? "bg-white/20 text-white"
                        : "text-gray-200 hover:bg-white/10 hover:text-white",
                      "block rounded-lg px-3 py-2.5 text-base font-semibold transition-all",
                    )}
                    aria-current={item.current ? "page" : undefined}
                  >
                    {t(item.key, item.name)}
                  </DisclosureButton>
                ))}

                <div>
                  {!data ? (
                    <div className="flex flex-col items-center mt-4 space-y-3">
                      <a
                        href="registerOrganizer"
                        className="text-white w-full text-center font-semibold bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 transition-all duration-200 flex items-center justify-center px-4 py-2.5 rounded-lg shadow-md hover:shadow-lg"
                      >
                        {t("nav.create_events", "Create Events")}
                      </a>

                      <Menu as="div" className="relative w-full">
                        <div>
                          <MenuButton className="relative flex mt-2 text-sm w-full">
                            <button className="text-white w-full font-semibold bg-white/10 hover:bg-white/20 border border-white/30 hover:border-white/50 transition-all duration-200 rounded-lg p-2.5 px-5 shadow-md hover:shadow-lg">
                              {t("nav.login", "Login")}
                            </button>
                          </MenuButton>
                        </div>
                        <Transition
                          as={Fragment}
                          enter="transition ease-out duration-100"
                          enterFrom="transform opacity-0 scale-95"
                          enterTo="transform opacity-100 scale-100"
                          leave="transition ease-in duration-75"
                          leaveFrom="transform opacity-100 scale-100"
                          leaveTo="transform opacity-0 scale-95"
                        >
                          <MenuItems className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-xl bg-white shadow-xl ring-1 ring-black ring-opacity-5 focus:outline-none overflow-hidden">
                            <MenuItem>
                              {({ focus }) => (
                                <a
                                  href="/login"
                                  className={classNames(
                                    focus
                                      ? "bg-gradient-to-r from-indigo-50 to-purple-50"
                                      : "",
                                    "px-4 py-3 text-sm text-gray-700 font-medium flex items-center gap-2 transition-colors",
                                  )}
                                >
                                  <CiUser size={18} />
                                  Attendee Login
                                </a>
                              )}
                            </MenuItem>

                            <MenuItem>
                              {({ focus }) => (
                                <a
                                  href="/organizerLogin"
                                  className={classNames(
                                    focus
                                      ? "bg-gradient-to-r from-indigo-50 to-purple-50"
                                      : "",
                                    "flex items-center gap-2 px-4 py-3 text-sm text-gray-700 font-medium transition-colors",
                                  )}
                                >
                                  <CiCalendar size={18} />
                                  Organizer Login
                                </a>
                              )}
                            </MenuItem>
                          </MenuItems>
                        </Transition>
                      </Menu>
                    </div>
                  ) : (
                    <>
                      <Menu as="div" className="relative ml-3">
                        <div className="flex text-center items-center text-white space-x-2 mt-4">
                          <div className="hidden sm:block">
                            <p className="font-medium">
                              Hello, {data?.username}
                            </p>
                          </div>
                          <MenuButton className="relative flex rounded-full bg-white/20 hover:bg-white/30 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-slate-800 transition-all">
                            <span className="absolute -inset-1.5" />
                            <span className="sr-only">Open user menu</span>
                            {data?.photo ? (
                              <img
                                className="h-8 w-8 rounded-full"
                                src={data?.photo}
                                alt={`${data?.first_name || "User"
                                  }'s profile picture`}
                              />
                            ) : (
                              <FontAwesomeIcon
                                icon={faUser}
                                className="h-8 w-8 text-white"
                              />
                            )}
                          </MenuButton>
                        </div>
                        <Transition
                          as={Fragment}
                          enter="transition ease-out duration-100"
                          enterFrom="transform opacity-0 scale-95"
                          enterTo="transform opacity-100 scale-100"
                          leave="transition ease-in duration-75"
                          leaveFrom="transform opacity-100 scale-100"
                          leaveTo="transform opacity-0 scale-95"
                        >
                          <MenuItems className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-xl bg-white shadow-xl ring-1 ring-black ring-opacity-5 focus:outline-none overflow-hidden">
                            <MenuItem>
                              {({ focus }) => (
                                <a
                                  href={dashBoardLink}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className={classNames(
                                    focus
                                      ? "bg-gradient-to-r from-indigo-50 to-purple-50"
                                      : "",
                                    "block px-4 py-3 text-sm text-gray-700 font-medium transition-colors",
                                  )}
                                >
                                  Your Profile
                                </a>
                              )}
                            </MenuItem>

                            <MenuItem>
                              {({ focus }) => (
                                <button
                                  onClick={handleLogout}
                                  className={classNames(
                                    focus
                                      ? "bg-red-50 text-red-700"
                                      : "text-gray-700",
                                    "block w-full text-left px-4 py-3 text-sm font-medium transition-colors",
                                  )}
                                  type="button"
                                >
                                  Logout
                                </button>
                              )}
                            </MenuItem>
                          </MenuItems>
                        </Transition>
                      </Menu>
                    </>
                  )}
                </div>
              </div>
            </DisclosurePanel>
          </>
        )}
      </Disclosure>
    </>
  );
}
